// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v3.21.12
// source: opentrace/v1/agent_service.proto

/* eslint-disable */
import type { GitIntegrationConfig } from "./job_config";

export const protobufPackage = "opentrace.v1";

/**
 * JobPhase represents the current stage of an indexing pipeline.
 * These phases are shared between browser and server indexing paths.
 */
export const JobPhase = {
  JOB_PHASE_UNSPECIFIED: 0,
  JOB_PHASE_INITIALIZING: 1,
  JOB_PHASE_FETCHING: 2,
  JOB_PHASE_PARSING: 3,
  JOB_PHASE_RESOLVING: 4,
  JOB_PHASE_ENRICHING: 5,
  JOB_PHASE_SUBMITTING: 6,
  JOB_PHASE_DONE: 7,
  JOB_PHASE_SUMMARIZING: 8,
  JOB_PHASE_EMBEDDING: 9,
  JOB_PHASE_NORMALIZING: 10,
  JOB_PHASE_PERSISTING: 13,
  UNRECOGNIZED: -1,
} as const;

export type JobPhase = typeof JobPhase[keyof typeof JobPhase];

export namespace JobPhase {
  export type JOB_PHASE_UNSPECIFIED = typeof JobPhase.JOB_PHASE_UNSPECIFIED;
  export type JOB_PHASE_INITIALIZING = typeof JobPhase.JOB_PHASE_INITIALIZING;
  export type JOB_PHASE_FETCHING = typeof JobPhase.JOB_PHASE_FETCHING;
  export type JOB_PHASE_PARSING = typeof JobPhase.JOB_PHASE_PARSING;
  export type JOB_PHASE_RESOLVING = typeof JobPhase.JOB_PHASE_RESOLVING;
  export type JOB_PHASE_ENRICHING = typeof JobPhase.JOB_PHASE_ENRICHING;
  export type JOB_PHASE_SUBMITTING = typeof JobPhase.JOB_PHASE_SUBMITTING;
  export type JOB_PHASE_DONE = typeof JobPhase.JOB_PHASE_DONE;
  export type JOB_PHASE_SUMMARIZING = typeof JobPhase.JOB_PHASE_SUMMARIZING;
  export type JOB_PHASE_EMBEDDING = typeof JobPhase.JOB_PHASE_EMBEDDING;
  export type JOB_PHASE_NORMALIZING = typeof JobPhase.JOB_PHASE_NORMALIZING;
  export type JOB_PHASE_PERSISTING = typeof JobPhase.JOB_PHASE_PERSISTING;
  export type UNRECOGNIZED = typeof JobPhase.UNRECOGNIZED;
}

/** JobEventKind discriminates the event type within a JobEvent stream. */
export const JobEventKind = {
  JOB_EVENT_KIND_UNSPECIFIED: 0,
  JOB_EVENT_KIND_PROGRESS: 1,
  JOB_EVENT_KIND_GRAPH_READY: 2,
  JOB_EVENT_KIND_DONE: 3,
  JOB_EVENT_KIND_ERROR: 4,
  JOB_EVENT_KIND_STAGE_COMPLETE: 5,
  UNRECOGNIZED: -1,
} as const;

export type JobEventKind = typeof JobEventKind[keyof typeof JobEventKind];

export namespace JobEventKind {
  export type JOB_EVENT_KIND_UNSPECIFIED = typeof JobEventKind.JOB_EVENT_KIND_UNSPECIFIED;
  export type JOB_EVENT_KIND_PROGRESS = typeof JobEventKind.JOB_EVENT_KIND_PROGRESS;
  export type JOB_EVENT_KIND_GRAPH_READY = typeof JobEventKind.JOB_EVENT_KIND_GRAPH_READY;
  export type JOB_EVENT_KIND_DONE = typeof JobEventKind.JOB_EVENT_KIND_DONE;
  export type JOB_EVENT_KIND_ERROR = typeof JobEventKind.JOB_EVENT_KIND_ERROR;
  export type JOB_EVENT_KIND_STAGE_COMPLETE = typeof JobEventKind.JOB_EVENT_KIND_STAGE_COMPLETE;
  export type UNRECOGNIZED = typeof JobEventKind.UNRECOGNIZED;
}

/** RunJobRequest is sent by the API server to the Python agent to start indexing. */
export interface RunJobRequest {
  mcpUrl: string;
  apiKey: string;
  gitIntegrations: GitIntegrationConfig[];
}

/** IndexedNode represents a single graph node produced during indexing. */
export interface IndexedNode {
  id: string;
  type: string;
  name: string;
  propertiesJson: string;
}

/** IndexedRelationship represents a single graph relationship produced during indexing. */
export interface IndexedRelationship {
  id: string;
  type: string;
  sourceId: string;
  targetId: string;
  propertiesJson: string;
}

/**
 * JobEvent is a single event in a streaming indexing job.
 * The `kind` field determines which fields are meaningful:
 *   - PROGRESS:    phase, message, detail
 *   - GRAPH_READY: result (partial counts so far)
 *   - DONE:        result (final counts), errors
 *   - ERROR:       message, errors
 */
export interface JobEvent {
  kind: JobEventKind;
  phase: JobPhase;
  message: string;
  result: JobResult | undefined;
  errors: string[];
  detail:
    | ProgressDetail
    | undefined;
  /** Batch payloads (for server-side streaming — nodes/rels inline with progress) */
  nodes: IndexedNode[];
  relationships: IndexedRelationship[];
}

/** ProgressDetail provides numeric progress within a phase. */
export interface ProgressDetail {
  current: number;
  total: number;
  fileName: string;
  nodesCreated: number;
  relationshipsCreated: number;
}

/** JobResult summarises the outcome of an indexing run. */
export interface JobResult {
  nodesCreated: number;
  relationshipsCreated: number;
  reposProcessed: number;
}
